import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/projects/1.png";
import ProjectImg2 from "../../assets/img/projects/2.png";
import ProjectImg3 from "../../assets/img/projects/3.png";
import ProjectImg4 from "../../assets/img/projects/4.png";
import ProjectImg5 from "../../assets/img/projects/5.png";
import ProjectImg6 from "../../assets/img/projects/6.png";
import AddImage2 from "../../assets/img/add/add2.png";

export default function Projects() {
  return (
    <Wrapper id="solutions">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What Click Law delivers</h1>
            <p className="font13">
              Click Law is the digital backbone of modern legal practice—integrating case management, legal knowledge systems, and intelligent automation into a single secure ecosystem.
              <br />
              Every feature reflects litigation workflow, legal documentation, case organisation, and legal research processes.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg1}
                title="Manage Cases with the Precision Legal Work Demands"
                text="Click Law provides a structured system for organising every aspect of a legal matter. Track cases from initiation to resolution, manage deadlines and key dates, organise documents and correspondence, collaborate securely across teams."
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg2}
                title="Legal Knowledge, Instantly Accessible"
                text="Click Law integrates intelligent search and jurisdiction-aware legal databases. Locate relevant authorities quickly, analyse case law efficiently, and access legal knowledge within seconds. Legal intelligence should never be difficult to access."
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg3}
                title="Built with Legal Ethics in Mind"
                text="Confidentiality lies at the heart of legal practice. Click Law was designed with the highest standards of security: encrypted cloud infrastructure, controlled access permissions, comprehensive audit logs, and ethical AI governance safeguards. Legal data is sacred—Click Law protects it accordingly."
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg4}
                title="Meet Click Companion, Your AI Legal Assistant"
                text="Click Companion is an intelligent legal assistant embedded within the Click Law platform. It helps lawyers search legal authorities faster, analyse legal questions intelligently, generate research summaries, and assist with drafting and legal reasoning. Designed to amplify expertise, not replace it."
                action={() => document.getElementById("insights")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg5}
                title="Imagine a Law Firm That Runs Like Clockwork"
                text="A modern law firm should operate with clarity and efficiency. No lost documents. No endless searches. No administrative chaos. Instead: cases are organised, knowledge is accessible, deadlines are controlled, and lawyers focus on the law. This is the transformation Click Law makes possible."
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg6}
                title="Designed for Lawyers. Not Adapted for Them."
                text="Most software platforms attempt to adapt generic systems to the legal profession. Click Law was built from the ground up around the realities of legal work. Because legal practice requires precision, structure, and trust."
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "220px" }}>
              <FullButton title="Demo" action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} />
            </div>
          </div>
        </div>
      </div>
      <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="Click Law platform" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">Closing statement</h4>
              <h2 className="font40 extraBold">Click Law is more than software.</h2>
              <p className="font12">
                It is the infrastructure layer for modern legal practice, bringing together case management, legal knowledge, and artificial intelligence into a secure and intelligent platform. The future of the legal profession will belong to firms that are organised, intelligent, and technologically empowered.
              </p>
              <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                <div style={{ width: "190px" }}>
                  <FullButton title="Demo" action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton title="Contact Us" border action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
